/* LED Strip badge renderer - parses product title for watts/length and shows badges. */
(function () {
  function parseWatts(title) {
    var m = title.match(/(\d+(?:\.\d+)?)\s*W(?![A-Z\d])/i);
    if (!m) return null;
    var n = parseFloat(m[1]);
    if (n <= 0 || n > 50) return null;
    return n + 'W/M';
  }

  function parseLength(title) {
    var m = title.match(/[\s\-_](\d+(?:\.\d+)?)\s*M\b/i);
    if (!m) return null;
    var n = parseFloat(m[1]);
    if (n <= 0 || n > 100) return null;
    return n + 'M';
  }

  function tagOverrideLength(tags) {
    // Look for a tag like "length-5m", "length-2.5m", "length-30m"
    for (var i = 0; i < tags.length; i++) {
      var m = tags[i].match(/^length-(\d+(?:\.\d+)?)m?$/);
      if (m) return parseFloat(m[1]) + 'M';
    }
    return null;
  }

  function tagOverrideWatts(tags) {
    // Look for a tag like "watts-9.6", "watts-9.6w", "watts-14.4w"
    for (var i = 0; i < tags.length; i++) {
      var m = tags[i].match(/^watts-(\d+(?:\.\d+)?)w?$/);
      if (m) return parseFloat(m[1]) + 'W/M';
    }
    return null;
  }

  function process(el) {
    if (el.classList.contains('--led-processed')) return;
    el.classList.add('--led-processed');

    var title = el.dataset.title || '';
    var cutTo = el.dataset.cutToLength === '1';
    var tags = (el.dataset.tags || '').split('|').filter(Boolean);

    // Per-badge suppression flags
    var hideLength = tags.indexOf('no-length-badge') !== -1;
    var hideWatts  = tags.indexOf('no-watts-badge') !== -1;

    var leftText = '';
    var rightText = '';

    if (!hideLength) {
      // Override tag wins
      var lenOverride = tagOverrideLength(tags);
      if (lenOverride) {
        leftText = lenOverride;
      } else if (cutTo) {
        leftText = 'PER METER';
      } else {
        var len = parseLength(title);
        if (len) leftText = len;
      }
    }

    if (!hideWatts) {
      var wOverride = tagOverrideWatts(tags);
      if (wOverride) {
        rightText = wOverride;
      } else {
        var w = parseWatts(title);
        if (w) rightText = w;
      }
    }

    if (!leftText && !rightText) {
      el.style.display = 'none';
      return;
    }

    var html = '';
    html += leftText
      ? '<span class="led-badge led-badge--left">' + leftText + '</span>'
      : '<span class="led-badge-spacer"></span>';
    html += rightText
      ? '<span class="led-badge led-badge--right">' + rightText + '</span>'
      : '<span class="led-badge-spacer"></span>';
    el.innerHTML = html;
  }

  function run() {
    document.querySelectorAll('.led-strip-badges').forEach(process);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('halo:collection:loaded', run);
  document.addEventListener('halo:product-grid:updated', run);

  if (window.MutationObserver) {
    var debounce = null;
    var mo = new MutationObserver(function () {
      if (debounce) return;
      debounce = setTimeout(function () {
        debounce = null;
        run();
      }, 100);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
